module.exports = __webpack_public_path__ + "static/media/250-point-player.7e41103c.png";